import axios from "vue-app/utils/axios";
import { DTOProductPreviewResponse, DTOTrackerProduct } from "vue-app/api/dto";
import { BasicProductData } from "vue-app/utils/functions";

const seededShuffle = <T>(array: T[], seed: number): T[] => {
  const shuffled = [...array];
  let currentSeed = seed;

  const random = () => {
    currentSeed = (currentSeed * 9301 + 49297) % 233280;
    return currentSeed / 233280;
  };

  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
};

export const getExampleProducts = async (seed?: number) => {
  const ls = localStorage.getItem(`${window.EDRONE_CONTEXT.trackerId}__example-products-v2`);
  if (ls) {
    const parsed = JSON.parse(ls);
    if (Array.isArray(parsed) && parsed.length >= 3) {
      return seed !== undefined ? seededShuffle(parsed, seed) : parsed;
    }
  }

  try {
    const fetchProducts = async () => {
      const { data: products } = await axios.get<DTOTrackerProduct[]>("/products/example");

      const finalData = products?.length
        ? products
        : (
            await axios.get<DTOTrackerProduct[]>("/products/scrapped", {
              params: { url: window.EDRONE_CONTEXT.user.companyUrl },
            })
          ).data;

      return seed !== undefined ? seededShuffle(finalData, seed) : finalData;
    };

    const shuffledData = await fetchProducts();

    const basicDataMap = shuffledData.map((product) => {
      return {
        title: product.productTitle,
        price: product.actualPrice,
        oldPrice: product.productPrice,
        image: product.image,
      } as BasicProductData;
    });

    while (basicDataMap.length < 3 && basicDataMap.length > 0) {
      const productToDuplicate = basicDataMap[basicDataMap.length % basicDataMap.length];
      basicDataMap.push({ ...productToDuplicate });
    }

    localStorage.setItem(`${window.EDRONE_CONTEXT.trackerId}__example-products-v2`, JSON.stringify(basicDataMap));
    return basicDataMap;
  } catch (e) {
    console.error(e);
  }
  return [];
};

export const getProductsPreview = async () => {
  const { data } = await axios.get<DTOProductPreviewResponse>("/products/products-preview");
  return data;
};
